import { useRevealObserver } from "./hooks";
import { Hero } from "./Hero";
import { AssistantSection } from "./Assistant";
import {
  Nav,
  SignalChain,
  Resolve,
  ScheduleSection,
  Guard,
  Tally,
  Capabilities,
  Statement,
  SocialProof,
  Pricing,
  FAQ,
  Output,
} from "./Sections";

/**
 * TRACE landing page — the "SIGNAL" direction.
 *
 * Fully self-contained and token-driven: every style lives in `landing.css`,
 * scoped under `[data-lpv2]` so nothing leaks into (or collides with) the app
 * design system in `tokens.css`. The brand accent is a fixed orange defined in
 * CSS; the page ships dark-only for now (a `data-theme="light"` scope can be
 * added later). Motion respects `prefers-reduced-motion` and the `motion` prop.
 *
 * Rendered on the `/` route (eager, so its CSS ships in the main bundle and the
 * build-time prerender can hand real HTML to crawlers — see scripts/prerender).
 */
export function LandingPage({
  theme = "dark",
  motion = true,
}: { theme?: "dark" | "light"; motion?: boolean } = {}) {
  useRevealObserver(motion);

  return (
    <div data-lpv2 data-theme={theme} data-motion={motion ? "on" : "off"}>
      <Nav />
      <Hero motion={motion} />
      <SignalChain />
      <Resolve />
      <ScheduleSection />
      <Guard />
      <Tally />
      <AssistantSection />
      <Capabilities />
      <Statement />
      <SocialProof />
      <Pricing />
      <FAQ />
      <Output />
    </div>
  );
}

export default LandingPage;
